// Synchronous cache for the platform's active currency symbol, for the
// handful of plain (non-component) formatter helpers — e.g. referralUtils.ts
// money(), BonusWalletTurnoverShared.tsx money() — that can't call the
// useCurrencySymbol() hook themselves. Kept in sync by that hook, which is
// mounted for the lifetime of the app in AppLayout.
let activeCurrencySymbol = '';

export const setCurrencySymbol = (symbol: string | null | undefined) => {
  activeCurrencySymbol = symbol ?? '';
};

export const getCurrencySymbol = () => activeCurrencySymbol;
